import CityPageTemplate from './CityPageTemplate';

const cityData = {
  cityName: "Minneapolis",
  metaDescription: "Expert plumbing services in Minneapolis, MN. Bruce Nelson Plumbing & Heating provides residential and commercial plumbing, heating, and remodeling. Call 651-738-9354.",
  heroTitle: "Plumber in Minneapolis, MN",
  heroSubtitle: "Professional plumbing and heating solutions for Minneapolis homes and businesses.",
  introduction: "Need a trusted plumber in Minneapolis? Bruce Nelson Plumbing & Heating has been providing expert plumbing services to the City of Lakes since 1976. Whether you're in Uptown, Northeast, or the North Loop, our experienced technicians are ready to handle any plumbing challenge, from vintage bungalow repairs to modern high-rise installations.",
  services: [
    {
      title: "Residential Plumbing",
      description: "Full-service plumbing for Minneapolis homes, including repairs, installations, and remodels.",
      link: "/services/residential"
    },
    {
      title: "Commercial Plumbing",
      description: "Reliable commercial plumbing services for Minneapolis businesses of all sizes.",
      link: "/services/commercial"
    },
    {
      title: "Boiler Service",
      description: "Keep your Minneapolis home warm with our expert boiler services.",
      link: "/services/boilers"
    },
    {
      title: "Water Heater Repair",
      description: "Quick water heater repair and replacement throughout Minneapolis.",
      link: "/services/water-heaters"
    },
    {
      title: "Kitchen Remodeling",
      description: "Upgrade your Minneapolis kitchen with professional plumbing remodeling.",
      link: "/services/remodeling"
    },
    {
      title: "Sump Pump Service",
      description: "Protect your Minneapolis basement with our sump pump installation and repair.",
      link: "/services"
    }
  ],
  whyChooseUs: [
    "Nearly 50 years serving Minneapolis and the Twin Cities",
    "Fully licensed and insured Minnesota plumbing contractors",
    "Experts in older Minneapolis homes and unique plumbing systems",
    "Fair, upfront pricing on every job",
    "Quick response times to all Minneapolis neighborhoods",
    "Highly rated by Minneapolis homeowners"
  ],
  serviceAreas: [
    { name: "Saint Paul", link: "/plumber-saint-paul" },
    { name: "Oakdale", link: "/plumber-oakdale" },
    { name: "Woodbury", link: "/plumber-woodbury" },
    { name: "Eagan", link: "/plumber-eagan" },
    { name: "Maplewood", link: "/plumber-maplewood" },
    { name: "Lake Elmo", link: "/plumber-lake-elmo" }
  ],
  testimonial: {
    text: "Excellent service from start to finish. The technician was knowledgeable, friendly, and fixed our issue quickly. Best plumber in Minneapolis!",
    author: "Sarah M."
  }
};

const MinneapolisPage = () => <CityPageTemplate cityData={cityData} />;

export default MinneapolisPage;
